// removed by extract-text-webpack-plugin
module.exports = {"item":"vqYgWQfenc4PYEPuOrBn-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PromoBlock/PromoBlockItem/PromoBlockItem.scss
// module id = 1708
// module chunks = 0